var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileMovInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85489 1.86879L14.0589 0L43.1724 22.8426L43.8904 24.7895C44.3474 26.3681 44.0863 28.0729 43.1724 29.4621C42.3238 30.8512 40.8877 31.8615 39.2558 32.2403L14.0589 38.1757C13.602 38.302 13.0798 38.3652 12.5576 38.3652C11.3826 38.3652 10.2729 38.0495 9.22844 37.4812C7.79235 36.6603 6.74792 35.2712 6.35626 33.6926L0.220234 9.31961C-0.236704 7.74105 0.0244031 6.0362 0.938279 4.64706C1.78688 3.25793 3.22297 2.24765 4.85489 1.86879Z",
    transform: "translate(0.158691 38.585) scale(1 -1)",
    fill: "#201F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19486 1.0438H40.2912C43.6599 1.0438 46.4423 3.76515 46.4423 7.19697V40.303C46.4423 43.6734 43.7213 46.4562 40.2912 46.4562H7.19486C3.82622 46.4562 1.0438 43.7349 1.0438 40.303V7.19697C1.0438 3.82659 3.76479 1.0438 7.19486 1.0438Z",
    transform: "translate(11.1169 58.6812) scale(1 -1)",
    fill: "white",
    stroke: "#201F1F",
    strokeWidth: 2.08761
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(17.8071 52.2534) scale(1 -1)",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(17.8071 44.6133) scale(1 -1)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(17.8071 37.0364) scale(1 -1)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59913H3.72078V0Z",
    transform: "translate(17.8071 29.3953) scale(1 -1)",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H1.99209e-06V3.59912H3.72078V0Z",
    transform: "translate(47.6387 52.2534) scale(1 -1)",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H1.99209e-06V3.59912H3.72078V0Z",
    transform: "translate(47.6387 44.6133) scale(1 -1)",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H1.99209e-06V3.59912H3.72078V0Z",
    transform: "translate(47.6387 37.0364) scale(1 -1)",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H1.99209e-06V3.59913H3.72078V0Z",
    transform: "translate(47.6387 29.3953) scale(1 -1)",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59913H3.72078V0Z",
    transform: "translate(17.8071 22.0876) scale(1 -1)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H1.99209e-06V3.59913H3.72078V0Z",
    transform: "translate(47.6387 22.0876) scale(1 -1)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.718045 15.9435C0.587491 15.9435 0.456937 15.9435 0.391661 15.8803C0.130553 15.7541 4.98023e-07 15.5015 4.98023e-07 15.2489V0.726139C4.98023e-07 0.473569 0.130553 0.220998 0.391661 0.0947133C0.652768 -0.0315718 0.913877 -0.0315718 1.10971 0.0947133L13.3165 7.35611C13.5123 7.48239 13.6429 7.73496 13.6429 7.98753C13.6429 8.2401 13.5123 8.42953 13.3165 8.61896L1.10971 15.8172C0.979154 15.8803 0.848598 15.9435 0.718045 15.9435Z",
    transform: "translate(28.645 42.9983) scale(1 -1)",
    fill: "#C3272F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMovInner);
export default __webpack_public_path__ + "static/media/file-mov-inner.1f3aa24a4fa46095e9ffcb8733479ebd.svg";
export { ForwardRef as ReactComponent };